import { render, staticRenderFns } from "./JsonView.vue?vue&type=template&id=0a8a37a8&"
import script from "./JsonView.vue?vue&type=script&lang=ts&"
export * from "./JsonView.vue?vue&type=script&lang=ts&"
import style0 from "./JsonView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports